var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.5475 2.4675L10.5408 4.96417C12.7808 6.08417 12.7808 7.91583 10.5408 9.03583L5.5475 11.5325C2.1875 13.2125 0.816667 11.8358 2.49667 8.48167L3.00417 7.4725C3.1325 7.21583 3.1325 6.79 3.00417 6.53333L2.49667 5.51833C0.816667 2.16417 2.19333 0.7875 5.5475 2.4675Z",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.17333 7H6.32333",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteSend);
export default __webpack_public_path__ + "static/media/invite-send.895dfdfde9c0a0aac1dfad1e174d7fef.svg";
export { ForwardRef as ReactComponent };